import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbUmbType } from '@/models/alodb/AloDbUmbType'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getUmbTypes(): AxiosPromise<AlrContainer<AloBaseArray<AloDbUmbType>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/umbtype', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbUmbType>>(JSON.parse(data),AloDbUmbType.createAloDbUmbTypeArray)
      }]
    })
  },
  getUmbType(id:number):AxiosPromise<AlrContainer<AloDbUmbType>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/umbtype/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbUmbType>(JSON.parse(data),AloDbUmbType.createAloDbUmbTypeWithDetail)
      }]
    })
  },
  saveUmbType(umbType:AloDbUmbType):AxiosPromise<AlrContainer<AloDbUmbType>> {
    if(umbType.UMT_ID && umbType.UMT_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/umbtype/${umbType.UMT_ID}`, 
        method: 'PUT',
        data: umbType,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUmbType>(JSON.parse(data),AloDbUmbType.createAloDbUmbTypeWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/umbtype`, 
        method: 'POST',
        data: umbType,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUmbType>(JSON.parse(data),AloDbUmbType.createAloDbUmbTypeWithDetail)
        }]
      })    
    }
    
  }
  
}